<template>
  <a class="CollectionBack"
     :href="PAGE_PATH.BASE_URL+ PAGE_PATH.TOPIC.DEFAULT" target="_blank"
     :style="{backgroundImage:'url('+ IMG_BASE_URL +pic+') '}"
  >
    <span>返回专题列表</span>
  </a>
</template>

<script>
import {IMG_BASE_URL} from "@/constant/PATH";
import {PAGE_PATH} from "@/constant/PAGE_PATH";

export default {
  name: "CollectionBack",
  props:{
    pic: String
  },
  data(){
    return{
      IMG_BASE_URL,
      PAGE_PATH
    }
  }
}
</script>

<style lang="scss" scoped>
.CollectionBack{
  display: inline-block;
  width: 114px;
  height: 34px;
  border-radius: 0px 0px 22px 22px;
  text-align: center;
  line-height: 34px;
  font-size: 14px;
  color: #FFFFFF;
  overflow: hidden;
  background-color: rgba(0,0,0,0.18);
  backdrop-filter: blur(20px);
  cursor: pointer;

  span{
    display: inline-block;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.18);
  }
}
</style>
